import * as React from "react";
import styled from "styled-components";

import { createEntitiesConsumer } from "../../lib/entities";
import { User, CompanyMembership, Profile } from "../../entities";
import { media } from "../../common/utils/style";
import ExpandableText from "../../common/components/ExpandableText";
import MembershipProfilePost from "./MembershipProfilePost";

const UserEntitiesConsumer = createEntitiesConsumer<{
  user: User;
}>({ user: "users" });

const ProfileEntitiesConsumer = createEntitiesConsumer<{
  profile: Profile;
}>({ profile: "profiles" });

interface Props {
  membership: CompanyMembership;
  expanded: boolean;
  onExpand(): void;
}

class MembershipProfile extends React.PureComponent<Props> {
  public render() {
    const { membership } = this.props;
    return <UserEntitiesConsumer query={{ user: membership.user }}>{this.renderWithUser}</UserEntitiesConsumer>;
  }

  private renderWithUser: typeof UserEntitiesConsumer.children = ({ user }) => {
    const { expanded, onExpand } = this.props;
    if (!user) {
      return null;
    }
    return (
      <ProfileEntitiesConsumer query={{ profile: user!.profile }}>
        {({ profile }) => {
          if (!profile) {
            return null;
          }
          return (
            <>
              <MemberInfo>
                <Name>{user.name}</Name>
                <Position>{profile.position}</Position>
              </MemberInfo>
              {profile.introduction && (
                <Introduction>
                  <ExpandableText text={profile.introduction} limit={80} expanded={expanded} onExpand={onExpand} />
                </Introduction>
              )}
              {profile.cover_post && <MembershipProfilePost profile={profile} user={user} />}
            </>
          );
        }}
      </ProfileEntitiesConsumer>
    );
  };
}

const MemberInfo = styled.div`
  vertical-align: baseline;
  margin-bottom: 5px;
  @media ${media.medium} {
    margin-bottom: 12px;
  }
`;

const Name = styled.div`
  display: inline;
  font-size: 13px;
  font-weight: 600;
  @media ${media.medium} {
    font-size: 18px;
  }
`;

const Position = styled.div`
  display: inline;
  font-size: 11px;
  margin-left: 16px;
  color: rgba(0, 0, 0, 0.4);
  @media ${media.medium} {
    font-size: 16px;
    margin-left: 12px;
  }
`;

const Introduction = styled.div`
  font-size: 13px;
  margin-bottom: 12px;
  color: rgba(0, 0, 0, 0.8);
  @media ${media.medium} {
    margin-bottom: 24px;
  }
`;

export default MembershipProfile;



// WEBPACK FOOTER //
// ./frontend/src/company_memberships/components/MembershipProfile.tsx